import script from "./InvalidOrderAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvalidOrderAlert.vue?vue&type=script&setup=true&lang=ts"

import "./InvalidOrderAlert.vue?vue&type=style&index=0&id=8f80aab2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f80aab2"]])

export default __exports__